import { MenuItem } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { lang } from "../../../i18nLang";
import {
  AccessProfileStore,
  ContractStore,
  MessageStore,
} from "../../../store";
import { MenuLabel, SimpleMenu } from "../../UI/Menus";
import ModalMenuItem from "./ModalMenuItem";

import { EProcessNames } from "api/enums";
import ContractImportFromFile from "components/Importation/ContractImportFromFile";
import ContractDelete from "../../../components/Contract/ContractDelete";
import ContractExecutiveBudget from "../../../components/Contract/ContractExecutiveBudget";
import ContractForm from "../../Contract/ContractForm";
import TechnicalRetention from "../../Contract/TechnicalRetention";
import Taxes from "../../Taxes/Taxes";

const ContractMenu = (props: {
  anchorEl: Element | null;
  onClose: () => void;
}) => {
  const history = useHistory();

  const handleClickDiscounts = () => {
    if (!validateMenuAccess()) return;
    history.push(`/${ContractStore.getCurrentContract()?.uid}/discounts`);
  };

  const handleClickAdvances = () => {
    if (!validateMenuAccess()) return;
    history.push(`/${ContractStore.getCurrentContract()?.uid}/advances`);
  };

  const handleClickAddsAndCancels = () => {
    ContractStore.openAddsAndCancelsMenu();
  };

  const handleClickReadjustments = () => {
    if (!validateMenuAccess()) return;
    ContractStore.openReadjustment();
  };

  const validateMenuAccess = () => {
    if (
      !AccessProfileStore.validateAccessPermissionTo(
        EProcessNames.EDITAR_CONTRATO
      )
    ) {
      MessageStore.error(lang("userProfile.profileDoesNotAllow"));
      return false;
    }
    return true;
  };

  const validateCanDelete = () => {
    if (
      !AccessProfileStore.validateAccessPermissionTo(
        EProcessNames.EXCLUIR_CONTRATO
      )
    ) {
      MessageStore.error(lang("userProfile.profileDoesNotAllow"));
      return false;
    }
    return true;
  };

  return (
    <SimpleMenu
      anchorEl={props.anchorEl}
      keepMounted
      open={Boolean(props.anchorEl)}
      onClose={props.onClose}
      onClick={props.onClose}
    >
      {/* Importação e exportação */}
      <MenuLabel variant="body1" noWrap style={{ marginTop: "0.5rem" }}>
        {lang(`project.menu.importSection.title`)}
      </MenuLabel>
      <ModalMenuItem
        title={lang(`project.menu.importSection.import`)}
        Component={ContractImportFromFile}
        onBeforeOpen={validateMenuAccess}
      />
      {/* <MenuItem onClick={() => {}}>{lang("export")}</MenuItem> */}

      {/* Pârametro */}
      <MenuLabel variant="body1" noWrap>
        {lang(`project.menu.parameters.title`)}
      </MenuLabel>
      <ModalMenuItem
        title={lang(`project.menu.parameters.retention`)}
        Component={TechnicalRetention}
        onBeforeOpen={validateMenuAccess}
      />
      <MenuItem onClick={handleClickDiscounts}>
        {lang(`project.menu.parameters.discounts`)}
      </MenuItem>
      <ModalMenuItem
        title={lang(`project.menu.parameters.taxes`)}
        Component={Taxes}
        onBeforeOpen={validateMenuAccess}
      />
      <MenuItem onClick={handleClickAdvances}>
        {lang(`project.menu.parameters.advances`)}
      </MenuItem>

      {/* Configurações do contrato */}
      <MenuLabel variant="body1" noWrap>
        {lang(`project.menu.settings.title`)}
      </MenuLabel>
      {/* <MenuItem onClick={handleClickReadjustments}>
          {lang(`project.menu.settings.readjustments`)}
        </MenuItem> */}
      <MenuItem onClick={handleClickAddsAndCancels}>
        {lang(`project.menu.settings.addsAndCancels`)}
      </MenuItem>
      {/* <MenuItem onClick={() => {}}>{lang(`project.menu.settings.historic`)}</MenuItem> */}
      {/* <MenuItem onClick={() => {}}>{lang(`project.menu.settings.occurrence`)}</MenuItem> */}
      <ModalMenuItem
        title={lang(`project.menu.settings.link`)}
        Component={ContractExecutiveBudget}
        onBeforeOpen={validateMenuAccess}
      />
      {/* <MenuItem onClick={() => {}}>{lang(`project.menu.settings.file`)}</MenuItem> */}
      <ModalMenuItem
        title={lang(`project.menu.settings.edit`)}
        Component={ContractForm}
        onBeforeOpen={validateMenuAccess}
      />
      <ModalMenuItem
        title={lang(`project.menu.settings.delete`)}
        Component={ContractDelete}
        onBeforeOpen={validateCanDelete}
      />
    </SimpleMenu>
  );
};

export default ContractMenu;
